import './branch_users_transfer.dialog.component.scss'
import {Branch} from "../../model/Branch";
import {BranchesServiceName, ToastNotificationServiceName, UserServiceName} from "../../../utils/names/serviceNames";
import {BranchesService} from "../../../branches_service/service/branches-service";
import * as angular from "angular";
import {UserService} from "../../../users_service/service/user.service";
import {BranchUsers} from "../../model/BranchUsers";
import {getDefaultAvatarUrl} from "../../../users/model/User";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";

class CheckedUser extends BranchUsers {
    isChecked?: boolean
}

export class BranchUsersTransferDialogComponent {

    public static instance = (branch: Branch, users: BranchUsers[]) => ({
        template: require('./branch_users_transfer.dialog.component.html'),
        controller: [
            BranchesServiceName,
            UserServiceName,
            ToastNotificationServiceName,
            '$mdDialog',
            '$mdColors',
            'branch',
            BranchUsersTransferDialogComponent
        ],
        locals: {
            branch: branch,
            users: users
        }, bindings: {
            branch: '=',
            users: '=',
            setSelectedBranchId: '=',
            showLoader: '='
        },
        controllerAs: '$ctrl',
        bindToController: true
    });

    constructor(private branchService: BranchesService,
                private userService: UserService,
                private toastNotificationService: ToastNotificationService,
                private $mdDialog: angular.material.IDialogService,
                private $mdColor : angular.material.IColorService,
                private branch: Branch) {
        this.showLoader = true;
        this.transferAll = true;
    }

    private users: CheckedUser[];
    private selectedBranch;
    private showLoader: boolean;
    private transferAll: boolean;

    $onInit() {
        this.setDefaultAvatarIfNotExists(this.users);
        this.users.forEach(user => user.isChecked = false);
        this.showLoader = false;

    }

    private setDefaultAvatarIfNotExists(users: CheckedUser[]) {
        users.filter(user => !user.avatarUrl)
            .map(user => user.avatarUrl = getDefaultAvatarUrl(user.gender));
    }

    public setSelectedBranchId = (branchName: string) => {
        this.selectedBranch = branchName;
    };

    public markUserForTransfer(user: CheckedUser) {
        user.isChecked = !user.isChecked;
        this.transferAll = this.users.find(user => user.isChecked) == null
    }

    public transferBranchUsers() {
        if (this.selectedBranch != this.branch.branchName) {
            if (this.transferAll) {
                this.transferAllUsers();
            } else {
                this.transferCheckedUsers();
            }
        } else {
            this.toastNotificationService.generateWarningMessage('Selected users are already assigned to this branch!');
        }
    }

    public transferBranchUsersDisabled() {
        return this.showLoader;
    }

    private transferAllUsers() {
        this.showLoader = true;
        this.userService.updateUsersBranch(this.users, this.selectedBranch)
            .then((resp) => this.$mdDialog.hide())
    }

    private transferCheckedUsers() {
        this.showLoader = true;
        let checkedUsers = this.users.filter(u => u.isChecked);
        this.userService.updateUsersBranch(checkedUsers, this.selectedBranch)
            .then((resp) => {
                this.users = this.users.filter(u => !u.isChecked);
                this.transferAll = true;
                this.showLoader = false;
            })
    }

    public cancelTransfer() {
        this.$mdDialog.cancel();
    }

    public getBackground(user : CheckedUser) {
         return  user.isChecked? this.$mdColor.getThemeColor('default-primary-700') : null;
    }

}